<xt-ui-kit-dialog
  *transloco="let t"
  [config]="dialogConfig"
  [actionsTemplate]="actions"
  >
  <div mat-dialog-content class="dialog-content">
    @if (videos?.length) {
      <p class="dialog-text video-title">
        {{ t('app.dialog.support.video-title') }}
      </p>
    }
    @if (videos?.length) {
      <div class="video-container">
        <div class="scrollButton scrollButtonLeft">
          <xt-portal-button
            [style]="'basic-icon'"
            icon="chevron_left"
            color="none"
            [xTentionDummyCypress]="'dialog.info.left'"
            [ariaLabel]="t('app.labels.back')"
            (clickEvent)="scrollLeft()"
            />
          </div>
          <div #videoContainer class="video-content">
            @for (video of videos; track video) {
              <video
                class="video"
                description="FAQ Video"
                [xTentionDummyCypress]="'dialog-info.video'"
                controls
                >
                <source [src]="video.url" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            }
          </div>
          <div class="scrollButton scrollButtonRight">
            <xt-portal-button
              [style]="'basic-icon'"
              icon="chevron_right"
              color="none"
              [ariaLabel]="t('app.labels.next')"
              [xTentionDummyCypress]="'dialog.info.right'"
              (clickEvent)="scrollRight()"
              />
            </div>
          </div>
        }
        @if (loading) {
          <div class="spinner-container">
            <xt-ui-kit-spinner></xt-ui-kit-spinner>
          </div>
        }
        @if (faq?.length) {
          <p class="dialog-text accordion-title">
            {{ t('app.dialog.info.faq') }}
          </p>
        }
        @if (showContent) {
          <mat-accordion class="accordion">
            @for (item of faq; track item) {
              <mat-expansion-panel>
                <mat-expansion-panel-header
                  [xTentionDummyCypress]="'dialog-info.panel-header-question'"
                  >
                  <mat-panel-title>
                    {{ item.question }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div [innerHTML]="item.answer"></div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        }
      </div>
      @if (!faq?.length && !videos?.length && !loading) {
        <p>
          {{ t('app.dialog.support.noFAQ') }}
        </p>
      }
      <div class="dialog-content"></div>
      <ng-template #actions class="support-actions">
        @for (button of dialogTypes[data.type].buttons; track button) {
          <xt-portal-button
            [text]="t(button.text)"
            [style]="button.style"
            [textAlign]="'center'"
            (clickEvent)="button.click()"
            [ngClass]="button.class"
            [xTentionDummyCypress]="button.cypress"
            />
        }
      </ng-template>
    </xt-ui-kit-dialog>
